import React from "react";
import "./ComputingHero.css";
// import heroimg from "../containassets/heroimg.png";

export default function ComputingHero() {
  const counters = [
    {
      value: "41%",
      text: "Years in Containerization",
    },
    {
      value: "21%",
      text: "Experts in Docker & Kubernetes",
    },
    {
      value: "7h",
      text: "Projects Successfully Delivered",
    },
    {
      value: "60%",
      text: "Consistent Container Deployments",
    },
  ];

  const Counter = ({ className }) => (
    <div className={`counter ${className}`}>
      {counters.map((item, index) => (
        <div className="count" key={index}>
          <h2>{item.value}</h2>
          <span>{item.text}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div id="computing-hero" className="machinemainclass">
      <div className="hero">
        <div className="left">
          <div className="content">
            <h1>Continuous Delivery & Deployment (CD)</h1>
            <p>
              Partner with India's trusted machine learning experts delivering
              95% model accuracy and enterprise-grade solutions. As one of the
              best machine learning development services, we help businesses
              reduce manual efforts, optimize workflows, and accelerate digital
              transformation with proven ML strategies.
            </p>
            <button>Let's Discuss Your Project</button>
          </div>

          <Counter className="desktop-counter" />
        </div>
  </div>

      <Counter className="mobile-counter" />
    </div>
  );
}
